import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssService {

  // 🅰️ Fonts
  readonly fontSize2Xl = "text-2xl";
  readonly fontSize3Xl = "text-3xl";
  readonly fontSize4Xl = "text-4xl";
  readonly fontSize5Xl = "text-5xl";
  readonly fontSize6Xl = "text-6xl";
  readonly fontSize7Xl = "text-7xl";
  readonly fontSize8Xl = "text-8xl";
  readonly fontSize9Xl = "text-9xl";
  readonly fontSizeLg = "text-lg";
  readonly fontSizeMd = "text-base";
  readonly fontSizeSm = "text-sm";
  readonly fontSizeXl = "text-xl";
  readonly fontSizeXs = "text-xs";

  // 🪟 Marges / espaces
  readonly margin = "mb6";
  readonly marginBlock = "my-4";
  readonly marginBottom4 = "mb-4";
  readonly marginS = "mb4";
  readonly marginTop2 = "mt-2";
  readonly space = " ";

  // 👻 Visibilité / responsive
  readonly hiddenMd = "hidden md:block";
  readonly hiddenSm = "hidden sm:block";
  readonly hiddenXs = "hidden xs:block";

  // 🖋️ Table / liste
  readonly indentedLabelClass = "text-xs mt-1 ml-2 text-gray-500";
  readonly itemControlsClassMR = "flex items-center gap-2 mr-3"; //MR pour margin-right
  readonly itemControlsClassMB = "flex items-center gap-2 mb-2"; //MB pour margin-bottom
  readonly itemLabelClass = "font-medium";
  readonly itemLink = "font-medium text-emerald-600 dark:text-blue-500 hover:underline";
  readonly itemListClass = "py-4 px-4 items-center flex flex-row flex-nowrap";
  readonly itemListIconClass = "patch-color hidden md:block";
  readonly itemListSidenav = "flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-indigo-100 transition clicked rounded-md";
  readonly itemListSidenavIcon = "text-gray-600";
  readonly itemListSidenavText = "uppercase text-sm font-medium text-gray-800";
  readonly itemPriceClass = "font-bold";
  readonly itemRowClass = "flex justify-between items-center py-3 border-b border-dashed border-gray-300";
  readonly itemSmallListClass = "py-2 px-4 items-center flex flex-row flex-nowrap";
  readonly sharedLabelClass = "block text-xs text-green-700 mt-1";
  readonly shareItemListClass = "flex items-center justify-between p-2 mb-2 rounded bg-gray-100 hover:bg-green-200 cursor-pointer transition";
  readonly tableHeader = "whitespace-nowrap py-2 px-3 text-left text-xs font-semibold";
  readonly tableMiniRow = "whitespace-nowrap px-3";
  readonly tableRow = "whitespace-nowrap py-2 px-3";
  readonly listNone = "list-none p-0 my-4";

  // 📝 Formulaires
  readonly borderRadius = "rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400";
  readonly formInputClass = "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400";
  readonly formInputClassCenter = "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 text-center";
  readonly formLabelInputClass = "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2";
  readonly matFormFieldFullWidthMarginClass = "w-full mt-3";
  readonly sharedPartsControlClass = "flex items-center gap-2 mt-3";
  readonly sharedPartsInputClass = "w-12 text-center";

  // 🧩 Images / éléments visuels
  readonly posImageClass = "w-28 sm:w-40 rounded-lg h-auto";
  readonly productImageClass = "w-16 sm:w-20 rounded-lg h-auto";


  // 🏷️ Textes / titres / sous-titres
  readonly chipClass = "px-2 py-1 border rounded-full text-xs text-white text-center one-line";
  readonly columnHeader = "text-xs text-gray-500 one-line";
  readonly dialogTitleClass = "text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins";
  readonly itemListSubTitle1Class = "text-sm text-slate-500 uppercase";
  readonly itemListSubTitle2Class = "text-xs text-slate-500";
  readonly itemListTitleClass = "text-base font-bold uppercase";
  readonly listSubHeaderClass = "m-4 text-sm font-semibold text-500";
  readonly subtitlePageClass = "text-sm text-gray-800 font-semibold";
  readonly textAccent = "text-red-600";
  readonly textCenter = "text-center";
  readonly textGray = "text-gray-700";
  readonly textOrange = "text-orange-600";
  readonly textSuccess = "text-green-600";
  readonly titleCenteredMarginClass = "text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins text-center mb-4";
  readonly titlePageClass = "text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins";
  readonly dialogTitleErrorClass = "text-red-600 text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins";

  // 📦 Containers / sections
  readonly cardClass = "shadow rounded-lg bg-white";
  readonly cardMerchantClass = "bg-white rounded-lg shadow-md overflow-hidden flex flex-col";
  readonly cardPageClass = "shadow sm:rounded-lg bg-white";
  readonly cardProductClass = "flex flex-row items-center cursor-pointer relative h-full w-full shadow-md rounded-lg bg-white hover:bg-stone-50 p-4";
  readonly cardProductSquare = "cursor-pointer hover:bg-stone-50 bg-white rounded-md shadow-lg h-full w-full flex flex-col";
  readonly centerActionsWrapClass = "mx-auto max-w-2xl m-4 w-full";
  readonly dialogActionsClass = "flex justify-center gap-4 flex-wrap mt-4";
  readonly dialogContainerClass = "p-6 w-full max-w-full mx-auto bg-white rounded-t-2xl shadow-lg fontPoppins";
  readonly dialogContainerCenterClass = "p-6 w-full max-w-full mx-auto bg-white rounded-t-2xl shadow-lg fontPoppins text-center";
  readonly dialogContainerWideClass = "p-6 w-full max-w-full mx-auto bg-white rounded-t-2xl shadow-lg fontPoppins max-w-lg";
  readonly endActionsWrapClass = "flex justify-end gap-4 mt-4 flex-wrap";
  readonly endElement = "flex justify-end";
  readonly footerProductOrder = "full-w handle-sidenav-menu bg-gradient-to-r from-white via-white to-stone-100 border-t border-gray-300";
  readonly infoDialog = "p-4 max-w-md mx-auto bg-white rounded shadow";
  readonly mainPageClass = "p-0 sm:p-4";
  readonly paymentOptionsClass = "flex flex-col gap-3";
  readonly receiptContainerClass = "max-w-lg mx-auto bg-white rounded-2xl p-6 shadow";
  readonly receiptDetailsClass = "text-xs text-gray-700 mb-4 bg-white p-2 rounded-2xl flex justify-between mx-auto max-w-2xl";
  readonly receiptItemsClass = "border-y border-gray-200 py-4 my-4";
  readonly receiptPartialPaymentClass = "border-2 border-dashed border-gray-400 rounded-xl p-4 mt-4 bg-amber-50";
  readonly receiptSubtitleClass = "text-sm text-center text-gray-600 mb-6 text-sm text-gray-500 text-center";
  readonly receiptTitleClass = "text-xl font-bold text-center mb-2 text-2xl font-bold text-primary text-center";
  readonly receiptTotalClass = "text-right font-bold text-base mt-4";
  readonly sectionCardClass = "relative border border-gray-200 shadow-md rounded-lg p-4 bg-white";
  readonly sectionSubtitleClass = "my-4 text-center text-gray-700";
  readonly subtitleContentColumnClass = "text-sm text-gray-800 font-semibold flex flex-col gap-4 mb-6";
  readonly waitingNotesGlobal = "relative flex flex-col min-h-screen font-poppins bg-[url('/assets/img/waiting-notes/bg_banner2.png')] bg-cover bg-center text-gray-900 m-0";
  readonly noteFormatGlobal = "mx-auto max-w-2xl bg-white p-2 flex justify-center rounded-t-xl";

  // 🎨 Boutons / actions
  readonly actionButtonClass = "min-w-[140px] px-6 py-2 text-base";
  readonly authButtonToggle = "px-4 py-2 text-sm bg-indigo-50 text-gray-800 min-w-[180px]";
  readonly authButtonToggleSelected = "px-4 py-2 text-sm bg-indigo-50 text-gray-800 min-w-[180px] bg-indigo-200 font-semibold";
  readonly backButton = "flex flex-row text-sm items-center gap-2 px-3 py-2 rounded-full bg-gray-100 hover:bg-opacity-80 transition shadow-md border";
  readonly defaultActionButton = "px-6 py-2 rounded-full bg-gradient-to-r from-indigo-400 via-indigo-500 to-indigo-400 text-white font-medium shadow-md hover:brightness-110 transition";
  readonly defaultActionSMButton = "w-full rounded-full shadow-sm px-6 h-16 text-left transition mb-4 bg-opacity-90 hover:bg-opacity-70";
  readonly defaultNegativeDialogButton = "bg-gray-100 text-gray-800 py-1.5 rounded-full hover:bg-gray-300 transition border border-gray-300";
  readonly defaultPositiveDialogButton = "bg-indigo-600 text-white py-1.5 rounded-full hover:bg-indigo-700 transition";
  readonly defaultPrimaryButton = "bg-indigo-600 text-white py-2 rounded-full hover:bg-indigo-700 transition";
  readonly defaultSocialButton = "w-10 h-10 flex justify-center items-center rounded-full text-white hover:brightness-110 transition";
  readonly fullButtonActionClass = "bg-indigo-600 text-white py-2 rounded-full hover:bg-indigo-700 transition min-w-[140px] px-6 py-2 text-base";
  readonly fullNegativeButtonClass = "bg-gray-100 text-gray-800 py-1.5 rounded-full hover:bg-gray-300 transition border border-gray-300 min-w-[140px] px-6 py-2 text-base";
  readonly fullNegativeButtonDisabledClass = "bg-gray-100 text-gray-800 py-1.5 rounded-full hover:bg-gray-300 transition border border-gray-300 min-w-[140px] px-6 py-2 text-base min-w-[220px] opacity-50 cursor-not-allowed";
  readonly fullPrimaryButtonClass = "bg-indigo-600 text-white py-2 rounded-full hover:bg-indigo-700 transition min-w-[140px] px-6 py-2 text-base";
  readonly fullPrimaryButtonWideClass = "bg-indigo-600 text-white py-2 rounded-full hover:bg-indigo-700 transition min-w-[140px] px-6 py-2 text-base min-w-[220px]";
  readonly paymentButtonClass = "bg-emerald-700 hover:bg-emerald-900 text-white py-3 rounded-full font-bold w-full cursor-pointer transition disabled:opacity-50";
  readonly rubricNavButton = "cursor-pointer h-10 px-4 py-1 rounded-full text-white font-medium shadow-md transition";
  readonly scheduleButton = "text-sm sm:text-md px-4 py-1 rounded-full bg-transparent text-white bg-cyan-500 hover:bg-cyan-700 transition";
  readonly toolbarActionButton = "flex flex-row text-sm items-center gap-2 px-3 py-2 rounded-full text-white bg-indigo-500 hover:bg-opacity-80 transition shadow-md";
  readonly toolbarBgClass = "bg-gradient-to-r from-white via-white to-white h-auto h-16";
  readonly toolbarBgDashboardClass = "bg-gradient-to-r from-indigo-50 to-white h-16";
  readonly notePaidClass = "text-center text-base bg-blue-50 text-blue-600 py-3 rounded-lg font-bold mt-4";
  readonly validationButtonClass = "w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full";
  readonly cancelButtonClass = "bg-white w-full font-bold text-lg py-4 shadow-md rounded-full";
  // 🏷️ TipsDialog
  readonly tipButtonPrimary = "py-2 rounded-full font-semibold";
  readonly tipButtonSelected = "bg-primary text-white";
  readonly tipButtonUnselected = "bg-gray-100";
  readonly tipInputNumber = "w-24 text-center border rounded px-2 py-1";
  readonly tipDialogContainer = "bg-white rounded-xl p-6 shadow mx-auto max-w-2xl";
  readonly tipDialogTitle = "text-lg font-bold text-center mb-4";
  readonly tipGridContainer = "grid grid-cols-2 gap-4 mb-4";
  readonly tipInputContainer = "flex items-center justify-center gap-2 mb-4";
  readonly tipDialogButtons = "flex justify-end gap-2";

  constructor() { }
}
